module.exports = {
  twitterUrl: "https://twitter.com/kempsterrrr",
  githubUrl: "https://github.com/kempsterrrr",
}
